import './GlobalStyles.scss'
import '@fortawesome/fontawesome-free/css/all.css'

function GlobalStyles({ children }) {
    return children
}

export default GlobalStyles